<div
  class="overview-field {{viewName}}"
  [ngClass]="{'toneDownTextColor': toneDownTextColor}"
>
  @if (!overviewField.items || !overviewField.items.length) {
    <span class="overview-field__placeholder">
      {{ 'TRANS__ARRAY_FIELD__NO_INFORMATION' | translate }}
    </span>
  }

  @if (!isArrayValue) {
    <span
      class="overview-field__notLink-text"
      [ngClass]="{'expired': expired,
                  'one-line': viewName === 'selector',
                  'multiple-lines': viewName !== 'selector'}"
    >
      <app-overview-field-item
        [fieldItem]="overviewField.items[0]"
        [viewName]="viewName"
        [disableLinks]="disableLinks"
        [last]="true"
        [toneDownTextColor]="toneDownTextColor"
        [useMaterialSymbols]="useMaterialSymbols"
      ></app-overview-field-item>
    </span>
  }
  @else {
    <ng-container>
      @for (item of overviewField.items; track $index) {
        <span
          class="overview-field__item"
          [ngClass]="{'hide-value': $index > 0,
                      'has-show-more': overviewField.items.length > 1}"
        >
          @if ($index < 1) {
            <app-overview-field-item
              [fieldItem]="item"
              [disableLinks]="disableLinks"
              [viewName]="viewName"
              [last]="true"
              [toneDownTextColor]="toneDownTextColor"
              [useMaterialSymbols]="useMaterialSymbols"
            ></app-overview-field-item>
          }
        </span>
      }

      @if (overviewField.items.length > 1) {
        <button
          (pointerdown)="$event.stopPropagation()"
          (mousedown)="$event.stopPropagation()"
          (touchstart)="$event.stopPropagation()"
          (click)="$event.preventDefault(); $event.stopPropagation()"
          (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"
          (keydown.space)="$event.preventDefault(); $event.stopPropagation()"
          (menuOpened)="showMore = true;"
          (menuClosed)="showMore = false;"
          [ngClass]="{'active': showMore}"
          [matMenuTriggerFor]="toggleMore"
          [matTooltip]="'TRANS__OVERVIEW_FIELD_CONTENT__SHOW_MORE' | translate"
          matTooltipPosition="above"
          [attr.aria-label]="'TRANS__OVERVIEW_FIELD_CONTENT__SHOW_MORE' | translate"
          class="overview-field__show-more"
          mat-button
          type="button"
        >
          {{ overviewField.items.length - 1 }}
          <mat-icon iconPositionEnd>
            expand_more
          </mat-icon>
        </button>
      }


      <mat-menu
        #toggleMore="matMenu"
        (click)="$event.stopPropagation()"
        (keydown)="null"
        class="removePaddingInMatMenu overview-show-more-menu-panel"
      >
        <mat-list class="overview-show-more-menu">
          @for (item of overviewField.items; track $index; let last = $last) {
            <ng-container>
              @if ($index > 0) {
                <mat-list-item class="text-link">
                  <app-overview-field-item
                    [fieldItem]="item"
                    [viewName]="viewName"
                    [disableLinks]="disableLinks"
                    [toneDownTextColor]="false"
                    [last]="last"
                    [useMaterialSymbols]="useMaterialSymbols"
                  ></app-overview-field-item>
                </mat-list-item>
              }
            </ng-container>
          }
        </mat-list>
      </mat-menu>
    </ng-container>
  }
</div>
